/* @flow */
import * as barReportCashboxesActions from './actions';
import {List, fromJS, Record} from 'immutable';

const State = Record({
    barReportCashboxes: List(),
    showReportCashboxesCounter: false,
    showCloseReportButton: false
});

const BAR_REPORT_CASHBOXES = 'barReportCashboxes';
const SHOW_REPORT_CASHBOXES_COUNTER = 'showReportCashboxesCounter';
const SHOW_CLOSE_REPORT_BUTTON = 'showCloseReportButton';

const barReportCashboxesReducer = (state = new State(), action) => {

    switch (action.type) {

        case barReportCashboxesActions.SHOW_REPORT_CASHBOXES_COUNTER: {
            const {show, closeReport} = action.payload;
            return state
                .set(SHOW_REPORT_CASHBOXES_COUNTER, show)
                .set(SHOW_CLOSE_REPORT_BUTTON, closeReport);
        }

        case barReportCashboxesActions.FETCH_BAR_REPORT_CASHBOXES_SUCCESS: {
            return state.set(BAR_REPORT_CASHBOXES, fromJS(action.payload.data));
        }

        case barReportCashboxesActions.FETCH_BAR_REPORT_CASHBOXES_START:
        case barReportCashboxesActions.CLEAN_BAR_REPORT_CASHBOXES: {
            return state.set(BAR_REPORT_CASHBOXES, List());
        }

        case barReportCashboxesActions.POST_BAR_REPORT_CASHBOX_VALUE_SUCCESS: {
            const {id, type, amount, lastAmount} = action.payload.data;
            const amountType = type === 'START' ? 'beginningAmount' : 'endAmount';
            const coinsType = type === 'START' ? 'beginningCoins' : 'endCoins';

            const index = state.get(BAR_REPORT_CASHBOXES).findIndex(t =>
                t.get('id') === id
            );

            return state
                .setIn([BAR_REPORT_CASHBOXES, index, amountType], amount.amount)
                .setIn([BAR_REPORT_CASHBOXES, index, coinsType], amount.coins)
                .setIn([BAR_REPORT_CASHBOXES, index, 'lastAmount'], lastAmount);
        }

    }

    return state;
};

export default barReportCashboxesReducer;



// WEBPACK FOOTER //
// ./src/common/menu/report/cashboxes/reducer.js